<form [formGroup]="formGroup">
  @for (element of elements; track element; let i = $index) {
    @if (element.type === "radiogroup") {
      <div class="gds">
        <div class="gds-row">
          <div class="gds-q">
            <div class="gds-q-title">{{ i + 1 }}. {{ element.title }}</div>
          </div>
          <div class="gds-a">
            <nz-radio-group
              class="gds-segment"
              [nzButtonStyle]="'solid'"
              [formControlName]="element.name"
            >
              @for (choice of element.choices; track choice) {
                <label
                  nz-radio-button
                  [nzValue]="choice.value"
                  (click)="onRadioClick(element.name, choice.value)"
                >
                  {{ choice.text }}
                  {{ getChoicePoints(element.name, choice.text) }}
                </label>
              }
            </nz-radio-group>
          </div>
        </div>
      </div>
    }
  }
</form>
